import { render, staticRenderFns } from "./HeaderPanel.vue?vue&type=template&id=55a048bf&scoped=true"
import script from "./HeaderPanel.vue?vue&type=script&lang=js"
export * from "./HeaderPanel.vue?vue&type=script&lang=js"
import style0 from "./HeaderPanel.vue?vue&type=style&index=0&id=55a048bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a048bf",
  null
  
)

export default component.exports